import { gql } from '@apollo/client'

export const GET_TAX_RATE = gql`
query GetTaxRate ($input: GetTaxInput!) {
    getTaxRate (input: $input)
}
`
